const playTone = (ctx: AudioContext, freq: number, startTime: number, duration: number, type: OscillatorType = 'sine', volume: number = 0.1): void => {
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, startTime);
    osc.frequency.exponentialRampToValueAtTime(freq * 1.1, startTime + duration);

    g.gain.setValueAtTime(volume, startTime);
    g.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);

    osc.connect(g);
    g.connect(ctx.destination);

    osc.start(startTime);
    osc.stop(startTime + duration);
};

// Default entry point for notifications
export const playNotificationSound = (): void => {
    playAlertSound();
};

export const playDigitalSound = (): void => {
    try {
        const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
        const ctx = new AudioCtx();
        if (ctx.state === 'suspended') ctx.resume();
        playTone(ctx, 1200, ctx.currentTime, 0.05, 'square', 0.05);
        playTone(ctx, 1500, ctx.currentTime + 0.07, 0.05, 'square', 0.05);
        playTone(ctx, 1800, ctx.currentTime + 0.14, 0.05, 'square', 0.05);
        setTimeout(() => { if (ctx.state !== 'closed') ctx.close(); }, 500);
    } catch (e) { console.warn(e); }
};

export const playMusicalSound = (): void => {
    try {
        const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
        const ctx = new AudioCtx();
        if (ctx.state === 'suspended') ctx.resume();
        playTone(ctx, 1046.50, ctx.currentTime, 0.3, 'sine', 0.15);
        playTone(ctx, 1567.98, ctx.currentTime + 0.1, 0.5, 'sine', 0.1);
        setTimeout(() => { if (ctx.state !== 'closed') ctx.close(); }, 1000);
    } catch (e) { console.warn(e); }
};

export const playAlertSound = (): void => {
    try {
        const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
        const ctx = new AudioCtx();
        if (ctx.state === 'suspended') ctx.resume();
        // Clear Alert: A5 + E6
        playTone(ctx, 880, ctx.currentTime, 0.3, 'sine', 0.1);
        playTone(ctx, 1318.51, ctx.currentTime + 0.05, 0.3, 'sine', 0.1);
        setTimeout(() => { if (ctx.state !== 'closed') ctx.close(); }, 1000);
    } catch (e) { console.warn(e); }
};

export const playZenSound = (): void => {
    try {
        const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
        const ctx = new AudioCtx();
        if (ctx.state === 'suspended') ctx.resume();
        // Deep Singing Bowl like
        playTone(ctx, 220, ctx.currentTime, 1.5, 'sine', 0.2);
        playTone(ctx, 440, ctx.currentTime, 1.2, 'sine', 0.1);
        setTimeout(() => { if (ctx.state !== 'closed') ctx.close(); }, 2000);
    } catch (e) { console.warn(e); }
};

export const playPopSound = (): void => {
    try {
        const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
        const ctx = new AudioCtx();
        if (ctx.state === 'suspended') ctx.resume();
        // Short Bubble Pop
        const osc = ctx.createOscillator();
        const g = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(400, ctx.currentTime);
        osc.frequency.exponentialRampToValueAtTime(10, ctx.currentTime + 0.1);
        g.gain.setValueAtTime(0.2, ctx.currentTime);
        g.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.1);
        osc.connect(g);
        g.connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + 0.1);
        setTimeout(() => { if (ctx.state !== 'closed') ctx.close(); }, 200);
    } catch (e) { console.warn(e); }
};

export const playCrystalSound = (): void => {
    try {
        const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
        const ctx = new AudioCtx();
        if (ctx.state === 'suspended') ctx.resume();
        // High Crystal Ding
        playTone(ctx, 2093, ctx.currentTime, 0.1, 'sine', 0.1); // C7
        playTone(ctx, 2489, ctx.currentTime + 0.02, 0.4, 'sine', 0.08); // Eb7
        setTimeout(() => { if (ctx.state !== 'closed') ctx.close(); }, 1000);
    } catch (e) { console.warn(e); }
};
